import * as yup from 'yup';

yup.addMethod(yup.string, 'zipCode', function zipCode(message) {
  return this.when('country', ([{ value: country }], schema) => {
    switch (country.toUpperCase()) {
      case 'NL':
        return schema.matches(/^(?:[1-9]\d{3} ?(?:[A-RT-Z][A-Z]|S[BCE-RT-Z]))$/i, message);
      case 'DE':
        return schema.matches(/^(?:\d{5})$/i, message);
      case 'BE':
        return schema.matches(/^(?:\d{4})$/i, message);
      default:
        return schema.max(10, message);
    }
  });
});
